import React, { useState, useEffect } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
// import IconPicker from '../../IconPicker';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import FloatingLabelInput from '../../../../Custom/FloatingLabelInput';
import ButtonPreview from '../../../../ButtonPreview';
import { settingsFunctions } from '../../../../../functions/settings';
import './ButtonTypeReturn.css';

function ButtonTypeReturn(props) {    
    const { button, setButton, label, setLabel, buttonType, setButtonHasChanges, icon, setIcon, profile_theme } = props;

    const [ changes, setChanges ] = useState(true);
    const { buttonRefArr } = settingsFunctions;

    useEffect(()=> {
        if (button !== ""){
            setButtonHasChanges(true);
        } else{
            setButtonHasChanges(false);
        };
    },[changes, button, setButtonHasChanges]);

    switch(buttonType?.ref){
        case 'phone':
            return (
                <div className='button-type-container'>
                    <ButtonPreview button={buttonType} data={button} icon={icon} label={label} profile_theme={profile_theme}  />
                    <InputGroup>
                        <FloatingLabelInput
                            state={label}
                            setState={setLabel}
                            type="text"
                            id={`${buttonType.ref}Temp`}
                            label="Label (Optional)"
                            placeholder="Create a custom label for your button!"
                            maxLength='25'
                            style={{borderRadius: '2.5rem'}}
                        />
                    </InputGroup>
                    <InputGroup className='mb-3'>
                        <label className='mb-0 phone-label button-type-float' htmlFor='add-button-phone'>{`${buttonType.label}`}</label>
                        <PhoneInput
                            id="add-button-phone"
                            international
                            className='add-phone-input'
                            countryCallingCodeEditable={false}
                            placeholder='Enter phone number.'
                            defaultCountry='US'
                            value={button.replaceAll(' ','')}
                            onChange={setButton}
                            onKeyUp={() => setChanges(!changes)}
                        />
                    </InputGroup>          
                    <InputGroup className='mb-2'>
                        {/* <IconPicker icon={icon} setIcon={setIcon} setButtonHasChanges={null} /> */}
                    </InputGroup>
                </div>  
            );
        default:
            return (
                <div className='button-type-container'>
                    <ButtonPreview button={buttonType} data={button} icon={icon} label={label} profile_theme={profile_theme} />
                    <InputGroup>
                        <FloatingLabelInput
                            state={label}
                            setState={setLabel}
                            type="text"
                            id={`${buttonType.ref}Temp`}
                            label="Label (Optional)"
                            placeholder="Create a custom label for your button!"
                            maxLength='25'
                            style={{borderRadius: '2.5rem'}}
                        />
                    </InputGroup>
                    <InputGroup>
                        <FloatingLabelInput
                            state={button}
                            setState={setButton}
                            type={buttonType.ref === 'email' ? 'email' : buttonRefArr.includes(buttonType.ref) ? 'text' : 'url'}
                            id={`add-button-${buttonType.ref}`}
                            label={`${buttonType.label}`}
                            onKeyUp={() => setChanges(!changes)}
                            pattern={buttonType.ref !== 'email' && !buttonRefArr.includes(buttonType.ref) ? "(^((https|http)://)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$)|^((https|http)://)?(www.)?[a-z0-9]+.[a-z]+(/[a-zA-Z0-9#]+/?)*$" : null}
                            style={{borderRadius: '2.5rem'}}
                        />
                    </InputGroup>
                    <InputGroup className='mb-2'>
                        {/* <IconPicker icon={icon} setIcon={setIcon} setButtonHasChanges={null} /> */}
                    </InputGroup>
                </div>
            );
    };
};

export default ButtonTypeReturn;